export const mockedAnonFn = () => { }